import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa6';
import SafeIcon from './common/SafeIcon';
import { productCategories } from '../data/productCategories';

const { FiFacebook, FiInstagram } = FiIcons;
const { FaThreads } = FaIcons;

const Footer = () => {
  const socialLinks = [
    {
      icon: FiFacebook,
      url: 'https://www.facebook.com/huamo.official',
      label: 'Facebook',
      hoverColor: 'hover:text-blue-500'
    },
    {
      icon: FiInstagram,
      url: 'https://www.instagram.com/huamo.official/',
      label: 'Instagram',
      hoverColor: 'hover:text-pink-500'
    },
    {
      icon: FaThreads,
      url: 'https://www.threads.com/@huamo.official',
      label: 'Threads',
      hoverColor: 'hover:text-gray-400'
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img src="https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/logo.png" alt="Minipore" className="h-8 w-auto mr-3" />
              <span className="text-xl font-bold">Minipore</span>
            </div>
            <p className="text-gray-300 mb-6">
              Leading manufacturer of advanced membrane solutions for water treatment applications worldwide.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-gray-300">
                <MapPin className="w-4 h-4 mr-2" />
                <span className="text-sm">Shanghai, China</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Phone className="w-4 h-4 mr-2" />
                <span className="text-sm">+86 131-2227-7752</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Mail className="w-4 h-4 mr-2" />
                <span className="text-sm">johnny@minipore.com</span>
              </div>
            </div>
          </div>

          {/* Products Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Product Categories</h3>
            <ul className="space-y-3">
              {productCategories.slice(0, 5).map((category) => (
                <li key={category.id}>
                  <Link 
                    to={`/products?category=${encodeURIComponent(category.name)}`}
                    className="text-gray-300 hover:text-white transition-colors"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/products" className="text-blue-400 hover:text-blue-300 transition-colors font-medium">
                  View All Products →
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/culture" className="text-gray-300 hover:text-white transition-colors">
                  Our Culture
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Business Hours</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <Clock className="w-4 h-4 mr-2 mt-1 text-gray-400" />
                <div>
                  <div className="text-gray-300 text-sm">Monday - Friday</div>
                  <div className="text-white text-sm">9:00 AM - 5:30 PM</div>
                </div>
              </div>
              <div className="flex items-start">
                <Clock className="w-4 h-4 mr-2 mt-1 text-gray-400" />
                <div>
                  <div className="text-gray-300 text-sm">Saturday</div>
                  <div className="text-white text-sm">9:30 AM - 4:00 PM</div>
                </div>
              </div>
              <div className="flex items-start">
                <Clock className="w-4 h-4 mr-2 mt-1 text-gray-400" />
                <div>
                  <div className="text-gray-300 text-sm">Sunday</div>
                  <div className="text-white text-sm">Closed</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2026 Minipore. All rights reserved.
            </div>
            
            {/* Social Media Links */}
            <div className="flex space-x-6 mb-4 md:mb-0">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-gray-400 transition-colors duration-300 ${social.hoverColor}`}
                  aria-label={social.label}
                >
                  <SafeIcon icon={social.icon} className="h-6 w-6" />
                </a>
              ))}
            </div>

            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;